import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { useTasks } from '@/hooks/use-tasks'
import { useWorkspace } from '@/providers/workspace-provider'
import { useTaskActions } from '@/features/tasks/task-actions'
import { LABELS } from '@/lib/constants'
import { NAV } from './nav'
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'

export function CommandPalette({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (o: boolean) => void
}) {
  const navigate = useNavigate()
  const { data: tasks = [] } = useTasks()
  const { can } = useWorkspace()
  const { openCreate, openDetail } = useTaskActions()

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        onOpenChange(!open)
      }
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onOpenChange])

  const run = (fn: () => void) => {
    onOpenChange(false)
    fn()
  }

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Buscar tarefas ou navegar…" />
      <CommandList>
        <CommandEmpty>Nada encontrado.</CommandEmpty>

        {can.write && (
          <CommandGroup heading="Ações">
            <CommandItem onSelect={() => run(() => openCreate())}>
              <Plus className="h-4 w-4" /> Nova tarefa
            </CommandItem>
          </CommandGroup>
        )}

        <CommandGroup heading="Navegar">
          {NAV.map(({ to, label, icon: Icon }) => (
            <CommandItem key={to} value={`ir ${label}`} onSelect={() => run(() => navigate(to))}>
              <Icon className="h-4 w-4" /> {label}
            </CommandItem>
          ))}
        </CommandGroup>

        {tasks.length > 0 && (
          <CommandGroup heading="Tarefas">
            {tasks.slice(0, 20).map((t) => (
              <CommandItem
                key={t.id}
                value={`tarefa ${t.title}`}
                onSelect={() => run(() => openDetail(t.id))}
              >
                <span className="truncate">{t.title}</span>
                <span className="ml-auto text-xs text-muted-foreground">
                  {LABELS.status[t.status]}
                </span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  )
}
